<div class="ts-card">
    <app-position-search></app-position-search>
    <app-loading *ngIf="loading"></app-loading>
    <ng-container *ngIf="!loading && searchExecuted">
        <ng-container *ngIf="totalRecords > 0; else noRecordsFound">
            <table class="ts-table">
                <thead>
                    <tr>
                        <th class="header-vertical-border">Symbol</th>
                        <th class="text-right-numeric header-vertical-border">Quantity</th>
                        <th class="text-right-numeric header-vertical-border">Average Price</th>
                        <th class="header-vertical-border">Long/Short</th>
                        <th class="text-right-numeric header-vertical-border">Cost Basis</th>
                        <th class="text-right-numeric header-vertical-border">End of Day Price</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let element of pagedElements$ | async">
                        <tr class="element-row" [class.expanded-row]="element?.expanded" (click)="toggleRow(element)">
                            <td>{{element.symbol}}</td>
                            <td class="text-right-numeric">{{ element.quantity }}</td>
                            <td class="text-right-numeric">{{ element.avgPrice | currency:'USD':'symbol':'1.2-2'}}</td>
                            <td>{{ element.longShort | longShort }}</td>
                            <td class="text-right-numeric">{{ element.openPos | currency:'USD':'symbol':'1.2-2' }}</td>
                            <td class="text-right-numeric">{{ element.eodPrice | currency:'USD':'symbol':'1.2-2' }}</td>
                        </tr>
                        <tr class="detail-row" *ngIf="element?.expanded">
                            <td [attr.colspan]="displayedColumns.length">
                                <div class="element-detail">
                                    <app-loading *ngIf="element.loadingExpanded"></app-loading>
                                    <ng-container *ngIf="!element.loadingExpanded">
                                        <table class="ts-table inner-table" *ngIf="element.symbolDetail?.length > 0; else noDataFound">
                                            <thead>
                                                <tr>
                                                    <th class="text-right-numeric header-vertical-border">Quantity</th>
                                                    <th class="text-right-numeric header-vertical-border">Average Price</th>
                                                    <th class="header-vertical-border">Long/Short</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let detail of element.symbolDetail">
                                                    <td class="text-right-numeric">{{ detail.quantity }}</td>
                                                    <td class="text-right-numeric">{{ detail.avgPrice | currency:'USD':'symbol':'1.2-2' }}</td>
                                                    <td>{{ detail.longShort | longShort }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </ng-container>
                                    <ng-template #noDataFound>
                                        <app-empty-state
                                            [icon]="faChartPie"
                                            [compact]="true"
                                            headline="No detail available"
                                            hint="This symbol has no position breakdown to show."></app-empty-state>
                                    </ng-template>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
            <app-paginator [length]="totalRecords" [pageSize]="pageSize" [pageIndex]="pageIndex"
                (page)="pageChangeEvent($event)" [pageSizeOptions]="[25, 50, 100, 500]"></app-paginator>
        </ng-container>
    </ng-container>
    <ng-template #noRecordsFound>
        <app-empty-state
            [icon]="faChartPie"
            headline="No positions found"
            hint="No positions match your search. Try a different account or date."></app-empty-state>
    </ng-template>
    <app-empty-state *ngIf="!loading && !searchExecuted"
        [icon]="faMagnifyingGlass"
        headline="Search for positions"
        hint="Enter your search criteria above to view positions."></app-empty-state>
</div>
